import React, { useEffect, useState } from 'react';
import { Overlay, Popover } from 'react-bootstrap';

interface TodayPopoverProps {
	ganttContainerRef: React.MutableRefObject<HTMLDivElement | null>;
}

const TodayPopover: React.FC<TodayPopoverProps> = ({ ganttContainerRef }) => {
	const [isTodayHovered, setIsTodayHovered] = useState(false);
	useEffect(() => {
		const todayMarker = ganttContainerRef.current?.querySelector('.wx-content.x2-1ff484e') as HTMLElement | null;
		if (!todayMarker) return;
		const handleMouseOver = () => {
			setIsTodayHovered(true);
		};
		const handleMouseLeave = () => {
			setIsTodayHovered(false);
		};
		todayMarker.addEventListener('mouseover', handleMouseOver);
		todayMarker.addEventListener('mouseleave', handleMouseLeave);
		return () => {
			if (todayMarker) {
				todayMarker.removeEventListener('mouseover', handleMouseOver);
			}
		};
	}, [ganttContainerRef]);

	const [todayTarget, setTodayTarget] = useState<HTMLElement | null>(null);

	useEffect(() => {
		if (ganttContainerRef.current) {
			const todayMarker = ganttContainerRef.current.querySelector('.wx-content.x2-1ff484e');
			if (todayMarker instanceof HTMLElement) {
				setTodayTarget(todayMarker);
			}
		}
	}, [ganttContainerRef]);
	return (
		<Overlay show={isTodayHovered} target={todayTarget} placement="top">
			<Popover>
				<Popover.Body style={{ textAlign: 'center' }}>
					<div style={{ marginBottom: '1rem' }}>Giornata corrente</div>
					<div style={{ fontWeight: 700 }}>{new Date().toLocaleDateString('it-IT')}</div>
				</Popover.Body>
			</Popover>
		</Overlay>
	);
};

export default TodayPopover;
